<app-nav-bar *ngIf="showNavbar" class="nav-bar"></app-nav-bar>

<div class="progress" *ngIf="isLoadingLoader">
    <div class="progress-bar" style="width:0%" id="progressBar" #progressBar></div>
</div>

<router-outlet></router-outlet>